import { initConfigUnsafe } from '@cian/config/browser';
import { initLogger } from '@cian/logger/browser';
import { init as initTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { init as initWeb } from '@cian/web/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { initGlobalEventsLogs } from '@cian/events-log';

export const initDependencies = () => {
  initConfigUnsafe();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalBehaviors();
  initGlobalEventsLogs();
};
